function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_4384_7959)"
}, React.createElement("path", {
  d: "M2.91699 5.4165L3.63783 12.624C3.66861 12.9324 3.81288 13.2184 4.04263 13.4264C4.27238 13.6345 4.57122 13.7497 4.88116 13.7498H10.1195C10.4294 13.7497 10.7283 13.6345 10.958 13.4264C11.1878 13.2184 11.332 12.9324 11.3628 12.624L12.0837 5.4165",
  stroke: "#EC2B00",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M1.25 3.75H13.75",
  stroke: "#EC2B00",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M5.41699 3.75V1.25H9.58366V3.75",
  stroke: "#EC2B00",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_4384_7959"
}, React.createElement("rect", {
  width: 13.3333,
  height: 13.3333,
  fill: "white",
  transform: "translate(0.833008 0.833496)"
})));

const SvgTrashCan2 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTrashCan2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash-can 2.5d4834af.svg";
export { ForwardRef as ReactComponent };